import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ServiceInterfaceTableMessages = TableColumnsMessages & {
  platformColumn: string;
  descriptionColumn: string;
  isActiveColumn: string;
  intervalInSecondsColumn: string;
  lastExecutionColumn: string;
  isRunningColumn: string;
  isPausedColumn: string;
  countErrorsColumn: string;
  countSuccessColumn: string;
  settingsPopover: string;
  logsPopover: string;
  yesLabel: string;
  noLabel: string;
  internalPlatformLabel: string;
};

export const SERVICE_INTERFACE_TABLE_MESSAGES: ServiceInterfaceTableMessages = {
  platformColumn: "Plataforma",
  descriptionColumn: "Descrição do serviço",
  isActiveColumn: "Ativo",
  intervalInSecondsColumn: "Intervalo de execução (seg)",
  lastExecutionColumn: "Última execução",
  isRunningColumn: "Em execução",
  isPausedColumn: "Em pausa",
  countErrorsColumn: "Erros",
  countSuccessColumn: "Sucessos",
  settingsPopover: "Configurações",
  logsPopover: "Log",
  yesLabel: "Sim",
  noLabel: "Não",
  internalPlatformLabel: "Interno",
  ...TABLE_COLUMNS_MESSAGES,
};
